export const technologyTabButtons = [1, 2, 3];
